import React, { useEffect } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";
import { fetchUserSkins } from "../../../../actions/roblox/skinsActions";

import List from "../../Skins/_partials/_List";
import Card from "../../../../componets/Card";
import ListViewButtons from "../../../../componets/ListViewButtons";

const LIMIT = 42;
const DEFAULT_VIEW = 'grid';

const _Skins = ({ userId }: { userId: number | undefined }) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const listType: any   = queryParams.get(searchParams,'view') || DEFAULT_VIEW;

  useEffect(() => {
    if (!userId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      user_id: userId
    };

    dispatch(fetchUserSkins({ userId: userId, params }));
  }, [userId, currentPage, dispatch])

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Sticker Packs</h4>
        <ListViewButtons align='right' defaultType={DEFAULT_VIEW} className='v-mb-10' />

        <div>
          <List limit={LIMIT} pagination={true} type={listType} />
        </div>
      </Card>
    </>
  );
}

export default _Skins;
